module.exports = __webpack_public_path__ + "img/picture-4.0923f25c.png";